import './App.css';
import ProductsList from './components/ProductsList';

function App() {
  return (
    <div className="App">
      <ProductsList/>
    </div>
  );
}

export default App;
